import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import 'normalize.css/normalize.css';
import VueClipboard from 'vue-clipboard2';
import App from './app.vue';
import router from './router';
import store from './store';
import { historyURL } from '@/utils/historyURL';
// styles
import '@/assets/icons'; // icon
// 权限
import '@/permission';
import '@/assets/styles/index.scss';

Vue.use(VueClipboard);

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });

router.beforeEach((to, from, next) => {
  const { fullPath, query } = to;
  const { historyFlag } = query;
  if (!historyFlag) {
    historyURL.add(fullPath);
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
